import { useEffect } from 'react';

interface ImageLightboxProps {
  images: string[];
  index: number;
  alt: string;
  onClose: () => void;
  onChange: (index: number) => void;
}

export default function ImageLightbox({ images, index, alt, onClose, onChange }: ImageLightboxProps) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowRight' && images.length > 1) onChange((index + 1) % images.length);
      if (e.key === 'ArrowLeft' && images.length > 1) onChange((index - 1 + images.length) % images.length);
    };
    document.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [index, images.length, onChange, onClose]);

  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center bg-foreground-950/90 p-4" onClick={onClose}>
      <button
        type="button"
        aria-label="关闭"
        onClick={onClose}
        className="absolute top-4 right-4 w-11 h-11 flex items-center justify-center rounded-full bg-background-50/15 text-background-50 hover:bg-background-50/30 transition-colors"
      >
        <i className="ri-close-line text-2xl"></i>
      </button>

      <img
        src={images[index]}
        alt={alt}
        className="max-w-full max-h-[85vh] object-contain rounded-lg"
        onClick={(e) => e.stopPropagation()}
      />

      {images.length > 1 && (
        <>
          <button
            type="button"
            aria-label="上一张"
            onClick={(e) => {
              e.stopPropagation();
              onChange((index - 1 + images.length) % images.length);
            }}
            className="absolute left-4 md:left-8 top-1/2 -translate-y-1/2 w-11 h-11 flex items-center justify-center rounded-full bg-background-50/15 text-background-50 hover:bg-background-50/30 transition-colors"
          >
            <i className="ri-arrow-left-s-line text-2xl"></i>
          </button>
          <button
            type="button"
            aria-label="下一张"
            onClick={(e) => {
              e.stopPropagation();
              onChange((index + 1) % images.length);
            }}
            className="absolute right-4 md:right-8 top-1/2 -translate-y-1/2 w-11 h-11 flex items-center justify-center rounded-full bg-background-50/15 text-background-50 hover:bg-background-50/30 transition-colors"
          >
            <i className="ri-arrow-right-s-line text-2xl"></i>
          </button>
          <div className="absolute bottom-5 left-1/2 -translate-x-1/2 px-3 py-1.5 rounded-full bg-background-50/15 text-background-50 text-xs font-label">
            {index + 1} / {images.length}
          </div>
        </>
      )}
    </div>
  );
}